import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';

import ApiFactory from '@/api/apiFactory';

import type { LocalizationResponseItem } from '@/api/repositories/languageRepository';

const fakeLangList: any = {
  su: 'ru',
  be: 'by',
  sr: 'ser',
  ka: 'ge',
  el: 'gr',
  in: 'id',
  ind: 'in',
  hi: 'in',
  sl: 'slav',
};

const fakeLangResolver = (code: string): string => {
  if (fakeLangList[code]) {
    return fakeLangList[code];
  }
  return code;
};

const LanguageRepository = ApiFactory.get('language');

const columnResolver = (list: any, columns: number): any => {
  if (!list.length) {
    return [];
  }
  const perColumn = Math.ceil(list.length / columns);
  const resultList = [];
  for (let i = 0; i < columns; i += 1) {
    resultList.push(list.slice(i * perColumn, perColumn * (i + 1)));
  }
  return resultList;
};

class LanguageState {
  langList: LocalizationResponseItem[] = [];

  isLoaded = false;
}

class LanguageGetters extends Getters<LanguageState> {
  get list() {
    return this.state.langList;
  }

  get popularLanguage() {
    return columnResolver(this.state.langList.filter((item) => !item.popular), 3);
  }

  get otherLanguage() {
    return columnResolver(this.state.langList.filter((item) => !!item.popular), 3);
  }

  get currentLanguage() {
    return ((code: string) => this.state.langList.filter((item) => item.code === code).pop());
  }

  get firstLanguageInList() {
    return Array.isArray(this.state.langList) && this.state.langList.length ? this.state.langList[0].code : null;
  }

  get checkLanguageInList() {
    return ((code: string) => !!this.state.langList.filter((item) => item.code === code).length);
  }

  get languageListIsLoaded() {
    return this.state.isLoaded;
  }
}

class LanguageMutations extends Mutations<LanguageState> {
  update(payload: any) {
    this.state.langList = payload;
  }

  setLanguageListState(state: boolean) {
    this.state.isLoaded = state;
  }
}

class LanguageActions extends Actions<
  LanguageState,
  LanguageGetters,
  LanguageMutations,
  LanguageActions
> {
  async getAsyncData() {
    this.commit('setLanguageListState', false);
    return new Promise((resolve, reject) => {
      LanguageRepository.get()
        .then((repo: LocalizationResponseItem[]) => {
          repo.forEach((item: LocalizationResponseItem) => {
            item.fakeCode = fakeLangResolver(item.code);
          });
          this.commit('update', repo);
          this.commit('setLanguageListState', true);
          resolve(repo);
        })
        .catch((e) => {
          this.commit('update', []);
          this.commit('setLanguageListState', false);
          reject(e);
        });
    });
  }
}

// Экспорт модуля
export const LanguageModule = new Module({
  state: LanguageState,
  getters: LanguageGetters,
  mutations: LanguageMutations,
  actions: LanguageActions,
});

export const LanguageModuleMapper = createMapper(LanguageModule);
